var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWithdrawal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3523 15.3977C12.5719 15.6174 12.9281 15.6174 13.1478 15.3977L15.3978 13.1477C15.6174 12.9281 15.6174 12.5719 15.3978 12.3523L13.1478 10.1023C12.9281 9.88258 12.5719 9.88258 12.3523 10.1023C12.1326 10.3219 12.1326 10.6781 12.3523 10.8977L13.642 12.1875H6.75001C6.03869 12.1875 5.54281 12.187 5.15835 12.1521C4.78161 12.118 4.56743 12.0545 4.40625 11.9614C4.14972 11.8133 3.9367 11.6003 3.78859 11.3438C3.69553 11.1826 3.63203 10.9684 3.59789 10.5917C3.56304 10.2072 3.5625 9.71132 3.5625 9C3.5625 8.28869 3.56304 7.79281 3.59788 7.40834C3.63203 7.03161 3.69553 6.81743 3.78858 6.65625C3.93669 6.39972 4.14972 6.18669 4.40625 6.03858C4.56743 5.94553 4.78161 5.88203 5.15835 5.84788C5.54281 5.81304 6.03869 5.8125 6.75 5.8125H12C12.3107 5.8125 12.5625 5.56066 12.5625 5.25C12.5625 4.93934 12.3107 4.6875 12 4.6875H6.72317C6.04498 4.68749 5.49802 4.68749 5.0568 4.72748C4.60204 4.76869 4.20469 4.85592 3.84375 5.0643C3.4162 5.31115 3.06115 5.6662 2.8143 6.09375C2.60592 6.45469 2.51869 6.85204 2.47748 7.3068C2.43749 7.74802 2.43749 8.29498 2.4375 8.97316V9.02684C2.43749 9.70502 2.43749 10.252 2.47748 10.6932C2.5187 11.148 2.60592 11.5453 2.81431 11.9063C3.06116 12.3338 3.4162 12.6888 3.84375 12.9357C4.20469 13.1441 4.60204 13.2313 5.0568 13.2725C5.49802 13.3125 6.04498 13.3125 6.72316 13.3125L13.642 13.3125L12.3523 14.6023C12.1326 14.8219 12.1326 15.1781 12.3523 15.3977Z",
    fill: "#F7F6FD"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdrawal);
export default __webpack_public_path__ + "static/media/withdrawal.ac5b30b5d09f803ee590585816239d3a.svg";
export { ForwardRef as ReactComponent };